import React, { Component } from 'react';
import { withTheme } from '@emotion/react';
import getMonitor from '../utils/getMonitor.js';
class DevTools extends Component {
    constructor(props) {
        super(props);
        this.dispatch = (action) => {
            this.props.dispatch(action);
        };
        this.getMonitor(props, props.monitorState);
    }
    getMonitor(props, skipUpdate) {
        const monitorElement = getMonitor(props);
        this.monitorProps = monitorElement.props;
        this.Monitor = monitorElement.type;
        const update = this.Monitor.update;
        if (update) {
            let newMonitorState;
            const monitorState = props.monitorState;
            if (skipUpdate ||
                (monitorState && monitorState.__overwritten__ === props.monitor)) {
                newMonitorState = monitorState;
            }
            else {
                newMonitorState = update(this.monitorProps, undefined, {});
                if (newMonitorState !== monitorState) {
                    this.preventRender = true;
                }
            }
            this.dispatch({
                type: '@@INIT_MONITOR',
                newMonitorState,
                update,
                monitorProps: this.monitorProps,
            });
        }
    }
    UNSAFE_componentWillUpdate(nextProps) {
        if (nextProps.monitor !== this.props.monitor)
            this.getMonitor(nextProps);
    }
    shouldComponentUpdate(nextProps) {
        return (nextProps.monitor !== this.props.monitor ||
            nextProps.liftedState !== this.props.liftedState ||
            nextProps.monitorState !== this.props.monitorState ||
            nextProps.features !== this.props.features ||
            nextProps.theme.scheme !== this.props.theme.scheme);
    }
    render() {
        if (this.preventRender) {
            this.preventRender = false;
            return null;
        }
        const liftedState = {
            ...this.props.liftedState,
            monitorState: this.props.monitorState,
        };
        const MonitorAsAny = this.Monitor;
        return (React.createElement("div", { className: `monitor monitor-${this.props.monitor}` },
            React.createElement(MonitorAsAny, { ...liftedState, ...this.monitorProps, features: this.props.features, dispatch: this.dispatch, theme: this.props.theme, sortStateTreeAlphabetically: this.props.stateTreeSettings.sortAlphabetically, disableStateTreeCollection: this.props.stateTreeSettings.disableCollection })));
    }
}
export default withTheme(DevTools);
